import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';


const ACTIONS = {
    GET_DATA_ADMIN_USER_SUCCESS: 'GET_DATA_ADMIN_USER_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    ADD_ADMIN_USERS_SUCCESS: 'ADD_ADMIN_USERS_SUCCESS',
    ADD_ADMIN_USERS_ERROR: 'ADD_ADMIN_USERS_ERROR',
    UPDATE_ADMIN_USERS_SUCCESS: 'UPDATE_ADMIN_USERS_SUCCESS',
    UPDATE_ADMIN_USERS_ERROR: 'UPDATE_ADMIN_USERS_ERROR',
    DELETE_ADMIN_USERS_SUCCESS: 'DELETE_ADMIN_USERS_SUCCESS',
    DELETE_ADMIN_USERS_ERROR: 'DELETE_ADMIN_USERS_ERROR',
    GET_ROLES_SUCCESS: 'GET_ROLES_SUCCESS',
    GET_ROLES_ERROR: 'GET_ROLES_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getAdminUsers = (page, keyword) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/admin/staffs/users?sort=id&order=asc&keyword=${keyword}&page=${page}`
    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                // console.log(data);
                dispatch(updateStatus(ACTIONS.GET_DATA_ADMIN_USER_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_ERROR, err));
            });
    };
}

const addAdminUsers = (data) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            email: data.email,
            name: data.name,
            password: data.password,
            role_id: data.role_id
        })

    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/staffs/users`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.ADD_ADMIN_USERS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.ADD_ADMIN_USERS_ERROR, err));
            });
    };
}

const updateAdminUsers = (data, id) => {
    let param = {
        email: data.email,
        name: data.name
    };
    const config = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            email: data.email,
            name: data.name,
            password: data.password || null,
            role_id: data.role_id || null
        })

    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/staffs/users/${id}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.UPDATE_ADMIN_USERS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.UPDATE_ADMIN_USERS_ERROR, err));
            });
    };
}

const deleteAdminUsers = (id) => {
    const config = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        }
    };
    return (dispatch) => {
        callApi(`${host.serverTest}api/admin/staffs/users/${id}`, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.DELETE_ADMIN_USERS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.DELETE_ADMIN_USERS_ERROR, err));
            });
    };
}

// const searchUserAdmin = (text) => {
//     const config = {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
//         },
//     };

//     return (dispatch) => {
//         callApi(`${host.serverTest}api/admin/customers/users?keyword=${text}`,
//             config,
//             (data) => {
//                 dispatch(updateStatus(ACTIONS.GET_DATA_CLIENT_SUCCESS, data));
//             },
//             (err) => {
//                 dispatch(updateStatus(ACTIONS.GET_DATA_CLIENT_ERROR, err));
//             });
//     };
// }

// convert
const convertAdminUsers = (data) => {

    return data.map((items, index) => {
        // console.log(items.role.name);

        return {
            item: [
                { text: items.name, id: items.id },
                { text: items.email },
                { text: items.role.name, name : items.role.name, id:items.role.id },
                {
                    action: [
                        '設定変更', '削除'
                    ]
                }
            ]
        }
    });
};

// get list company
const getListRoles = () => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/masters/roles`,
            config,
            (data) => {

                dispatch(updateStatus(ACTIONS.GET_ROLES_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_ROLES_ERROR, err));
            });
    };
}

export { ACTIONS, getAdminUsers, convertAdminUsers, addAdminUsers, deleteAdminUsers, getListRoles, updateAdminUsers };